import Storage from './storage';
import { isNullOrUndefined } from '@/utils/helpers';

// private
const storage = new Storage();

// public
const getStorage = () => storage;

const getStorageValueWithFallback = (storage, key, fallback) => {
	const valueFromStorage = storage.getItem(key);
	return isNullOrUndefined(valueFromStorage) ? fallback : valueFromStorage;
};

const setStorageValueOrRemove = (storage, key, value) => {
	if (isNullOrUndefined(value)) {
		storage.removeItem(key);
	} else {
		storage.setItem(key, value);
	}
	return value;
};

const StorageService = {
	getStorage,
	getStorageValueWithFallback,
	setStorageValueOrRemove,
};

export default StorageService;
